<template>
  <div class="BossTop9" style="cursor: default">
    <div class="BossTop8">
      <div class="BossTop5">
        <img
          style="width: 90px; height: 90px; position: absolute; left: 0"
          src="../assets/official/image 17@2x.png"
          alt=""
        />
        <img
          style="
            width: 419px;
            height: 29px;
            position: absolute;
            left: 110px;
            top: 30px;
          "
          src="../assets/official/定制专属网校，限时优惠等你领取@2x.png"
          alt=""
        />
        <img
          style="
            width: 357px;
            height: 17px;
            position: absolute;
            left: 110px;
            top: 70px;
          "
          src="../assets/official/请填写并发送手机号码，客户经理将尽快与您联系！@2x.png"
          alt=""
        />
        <!-- <div style="color:#252525;margin-left: 282px;font-size: 28px;">立即领取 <span style="color: #FF6A11;">  企业数字化培训方案！ </span></div> -->
        <div style="display: flex">
          <el-input
            v-model="input"
            placeholder="请输入您的手机号码"
            class="yueon"
          ></el-input>
          <div class="yueon3" @click="dianhuan()">立即提交</div>
        </div>
      </div>
    </div>
    <el-dialog
      class="asdf"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
    >
      <img
        src="../assets//HelloWorld//tankuang111.png"
        alt=""
        style="width: 114px; height: 112px; padding: 32px 0 16px"
      />
      <div class="xxx_top">提交成功 ！</div>
      <div class="xxx_topy">我们会尽快安排专属人员为您服务~</div>
      <div class="xxx_topu">
        <div class="xxx_topu22" @click="dialogVisible = false">知道了</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { add } from '../api/util'
import { report, fff } from '@/js/utils'
import axios from 'axios'

export default {
  data() {
    return {
      input: '',
      dialogVisible: false,
    }
  },
  mounted() {},
  methods: {
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          done()
        })
        .catch((_) => {})
    },
    // 手机号验证
    dianhuan() {
      const ccc =
        /^[1](([3][0-9])|([4][0,1,4-9])|([5][0-3,5-9])|([6][2,5,6,7])|([7][0-8])|([8][0-9])|([9][0-3,5-9]))[0-9]{8}$/
      if (!ccc.test(this.input)) {
        this.$message.error('请正确填写联系方式！')
      } else {
        axios
          .get(
            'https://manager-api.mischool.com.cn' +
              '/official/mail?' +
              'mobile=' +
              this.input +
              '&industry=' +
              '来自底部信息提交无行业信息'
          )
          .then((res) => {
            if (res.data.code === 200) {
              console.log('发送成功')
              this.$message.success('提交成功')
              this.input = ''
            }
          })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.asdf ::v-deep .el-dialog {
  width: 470px !important ;
  height: 320px !important;
  border-radius: 8px;
}
.asdf ::v-deep .el-dialog__header {
  display: none;
}
.asdf ::v-deep .el-dialog__body {
  text-align: center;
  padding: 0;
}
.asdf .xxx_top {
  height: 28px;
  font-size: 20px;
  font-weight: bold;
  color: #eb5b05;
  margin-bottom: 12px;
}
.asdf .xxx_topy {
  height: 22px;
  font-size: 16px;
  font-weight: 500;
  color: #666666;
  margin-bottom: 16px;
}
.asdf .xxx_topu {
  display: flex;
  justify-content: center;
  height: 40px;
}
.asdf .xxx_topu22 {
  width: 270px;
  height: 40px !important;
  background: #eb5b05;
  border-radius: 4px;
  height: 28px;
  font-size: 20px;
  font-weight: 500;
  line-height: 40px;
  color: #ffffff;
}
.yueon3 {
  cursor: pointer !important;
  width: 200px;
  height: 40px;
  background-image: linear-gradient(to right, #03a0fc, #0274f7);
  border-radius: 4px;
  opacity: 1;
  font-size: 18px;
  text-align: center;
  line-height: 40px;
  color: #ffffff;
  margin: 0 0 0 40px;
}
.yueon ::v-deep .el-input__inner {
  width: 314px;
  height: 40px;
  font-size: 16px;
  padding: 0 40px;
  background: #ffffff;
}
.yueon {
  width: auto;
}
.BossTop9 {
  width: 100%;
  background: #ffffff;
  display: flex;
  align-items: center;
  flex-direction: column;
  color: #c1c1c1;
  position: fixed;
  bottom: 0;
  z-index: 9999;
  .BossTop8 {
    height: 100px;
    width: 2880px;
    background: url('../assets/official/Rectangle 543651@2x.png');
    background-size: cover;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    flex-direction: column;
    .DivYou {
      color: #ffffff;
    }
  }
  .BossTop5 {
    position: relative;
    width: 1200px;
    display: flex;
    align-items: center;
    justify-content: end;
    height: 100%;
    // flex-direction: column;
  }
  .YouBoss {
    height: 24px;
    font-size: 24px;
    font-weight: 500;
    line-height: 24px;
    margin-bottom: 24px;
  }
  .BossTop4 {
    width: 170px;
    height: 50px;
    background: #eb5b05;
    font-size: 18px;
    font-weight: 500;
    color: #ffffff;
    line-height: 51px;
    text-align: center;
  }
}
</style>
